<div
  class="w-full max-w-2xl bg-white dark:bg-neutral-1 rounded-3xl p-10 shadow-xl border border-neutral-3 dark:border-neutral-4 text-center"
>
  <div class="mb-8">
    <div
      class="w-20 h-20 bg-primary-2 text-primary-9 rounded-full flex items-center justify-center mx-auto mb-6"
    >
      <mat-icon class="w-10! h-10! text-[40px]">person_search</mat-icon>
    </div>
    <h2 class="text-3xl font-bold text-neutral-12 mb-4">{{ title() }}</h2>
    <p class="text-neutral-11 max-w-md mx-auto">
      {{ description() }}
    </p>
  </div>

  <div
    class="bg-neutral-2 dark:bg-neutral-2/60 rounded-2xl p-8 mb-10 text-left border border-neutral-3 dark:border-neutral-4"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <span class="text-xs font-bold uppercase tracking-wider text-neutral-8 dark:text-neutral-9 mb-1 block"
          >Prénom</span
        >
        <p class="text-xl font-semibold text-neutral-12">{{ currentUser()?.identity?.firstName }}</p>
      </div>
      <div>
        <span class="text-xs font-bold uppercase tracking-wider text-neutral-8 dark:text-neutral-9 mb-1 block"
          >Nom</span
        >
        <p class="text-xl font-semibold text-neutral-12">{{ currentUser()?.identity?.lastName }}</p>
      </div>
      <div>
        <span class="text-xs font-bold uppercase tracking-wider text-neutral-8 dark:text-neutral-9 mb-1 block"
          >Sexe</span
        >
        <p class="text-xl font-semibold text-neutral-12">{{ genderLabel() }}</p>
      </div>
      <div>
        <span class="text-xs font-bold uppercase tracking-wider text-neutral-8 dark:text-neutral-9 mb-1 block"
          >Date de naissance</span
        >
        <p class="text-xl font-semibold text-neutral-12">
          {{ currentUser()?.identity?.birthDate | date: 'd MMMM yyyy' : '' : 'fr-FR' }}
        </p>
      </div>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
    <a
      mat-button
      class="px-10! py-7! text-lg! w-full sm:w-auto"
      [routerLink]="errorLink()"
      [queryParams]="errorQueryParams()"
    >
      {{ errorLabel() }}
    </a>
    <button
      mat-flat-button
      class="px-10! py-7! text-lg! font-bold w-full sm:w-auto shadow-lg shadow-primary-4 hover:shadow-primary-5 transition-all primary"
      (click)="confirmed.emit()"
    >
      {{ confirmLabel() }}
    </button>
  </div>
</div>
